// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__gbwPL","insightsList":"newBusinessInsightsMenu_insightsList__SeQgr","active":"newBusinessInsightsMenu_active__3qzAk"};